<template>
  <div>
    <category-list @setCategory="setCategory" />
    <product-filter
      @updateFilter="updateFilter"
      @clearFilter="$emit('clearFilter')"
    />
    <styling-box
      :box="stylingBox"
      :complete="complete"
      @showBoxModal="$emit('showBoxModal')"
      @removeProduct="removeProduct"
      @editLetter="$emit('editLetter')"
      @completeOrder="$emit('completeOrder')"
      @selectProduct="emitSelectProduct"
    />
  </div>
</template>

<script>
import CategoryList from './CategoryList.vue'
import ProductFilter from './ProductFilter.vue'
import StylingBox from './StylingBox.vue'
export default {
  name: 'ProcessSidebar',
  props: {
    stylingBox: {
      type: Array,
      default: () => []
    },
    complete: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CategoryList,
    ProductFilter,
    StylingBox
  },
  methods: {
    setCategory (value) {
      this.$emit('updateCategory', value)
    },
    updateFilter (value) {
      this.$emit('updateFilter', value)
    },
    removeProduct (id) {
      this.$emit('removeProduct', id)
    },
    emitSelectProduct (product) {
      this.$emit('selectProduct', product)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
